// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5a47acb1","63":"329516f9","162":"1a83829f","324":"eb46200c","382":"fd603b3d","453":"3b50777a","704":"659df5c4","909":"3cd0c4bf"}[chunkId] + ".chunk.js";
};